<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <span>{{ prefix }}{{ displayValue }}{{ suffix }}</span>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, watch ,defineProps} from "vue";

const props = defineProps({
  to: { type: Number, required: true },
  duration: { type: Number, default: 1200 },
  suffix: { type: String, default: "" },
  prefix: { type: String, default: "" },
  decimals: { type: Number, default: 0 },
});

const displayValue = ref(0);
let rafId = null;
let isMounted = false;

const animate = (target) => {
  if (!isMounted) return;
  const start = displayValue.value;
  const startTime = performance.now();

  const run = (now) => {
    if (!isMounted) return;
    const elapsed = now - startTime;
    const progress = Math.min(elapsed / props.duration, 1);
    const easeOut = 1 - Math.pow(1 - progress, 3);
    const current = start + (target - start) * easeOut;
    displayValue.value = props.decimals > 0 ? current.toFixed(props.decimals) : Math.round(current);
    if (progress < 1) {
      rafId = requestAnimationFrame(run);
    }
  };
  rafId = requestAnimationFrame(run);
};

onMounted(() => {
  isMounted = true;
  animate(props.to);
});

onBeforeUnmount(() => {
  isMounted = false;
  if (rafId) cancelAnimationFrame(rafId);
});

watch(
  () => props.to,
  (newVal) => {
    if (isMounted) animate(newVal);
  }
);
</script>
